import React, {Fragment} from "react";
import {Controller} from "react-hook-form";
import {SmartErrorDiv} from "root/ReactHookForm/FormComponents/SmartErrorDiv";
import {LexicalRichTextEditor} from "root/ui/Lexical/LexicalRichTextEditor";

/**
 * react-hook-form rich text input, backed by Lexical, editing a plain HTML string
 *
 * @example
 *
 * <FormInputRichTextLexical readOnly={false}
 *                            sectionName={sectionName}
 *                            name={'letter_text'}
 *                            control={control}
 *                            maxLength={4000}
 *                            formErrors={formErrors}/>
 */
const FormInputRichTextLexical = ({ heading, name, sectionName, validate, control, maxLength = 1024, formErrors, readOnly = false }) =>
{
    const elementName = sectionName === undefined ? name : sectionName + '.' + name ;

    return (
        <Fragment key={elementName}>
            { heading != null && <label>{heading}</label> }
            <Controller
                control={control}
                name={elementName}
                defaultValue={''}
                rules={{ required: false, validate: validate}}
                render={({ field: { onChange, value } }) =>
                    <LexicalRichTextEditor key={'lex-' + elementName} namespace={elementName}
                                           readOnly={readOnly} value={value} onChange={onChange} showToolbar={false} />}
            />
            <SmartErrorDiv sectionName={sectionName}  name={name} maxLength={maxLength} formErrors={formErrors} />
        </Fragment>
    )
}

export { FormInputRichTextLexical };
